module.exports = __webpack_public_path__ + "first-200_watermark.jpg?b814d64660bcdfb976e8e26a9aa5302a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-200_watermark.jpg
// module id = 495
// module chunks = 0